<spt-help-content [showDivider]="showBackHeader">
  <spt-help-content-header *ngIf="showBackHeader">{{ helpTitle }}</spt-help-content-header>
  <spt-help-tooltip-header *ngIf="!showBackHeader" (closeModal)="closeModal()">{{ helpTitle }}</spt-help-tooltip-header>
  <spt-help-content-body>
    <spt-help-record-latency-content></spt-help-record-latency-content>
  </spt-help-content-body>
</spt-help-content>
